/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";

class Header extends Component {
  componentDidMount() {}

  renderProfileBar() {
    return (
      <div className="independent-service-profilebar">
        <a href="#">
          <div className="userArea">
            <div className="userInfoArea text-right">
              <div className="userName">
                {this.props.generalProfile.fullname}
              </div>
              <div className="userTitle">
                {this.props.generalProfile.positionName}
              </div>
              <div className="userCompanyTitle">
                {this.props.generalProfile.companyName}
              </div>
            </div>
            <div
              className={`userImgArea ${
                this.props.generalProfile.gradeType
                  ? this.props.generalProfile.gradeType.label
                  : ""
              }`}
            >
              {this.props.generalProfile.gradeType ? (
                <span className="icon-icon-menu-badge"></span>
              ) : null}
              <div
                className="userImg"
                style={{
                  backgroundImage: `url(/img/ford-gelisim-akademisi-avatar.svg)`,
                }}
              ></div>
            </div>
          </div>
        </a>

        <ul className="userSubmenu">
          <li className="cikisButonu">
            <a href="/logout">
              <span className="icon-icon-menu-logout"></span> <span>Çıkış</span>
            </a>
          </li>
        </ul>
      </div>
    );
  }

  render() {
    return (
      <>
        <header>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-5 col-sm-5 col-md-3 col-lg-3 col-xl-2 logoArea">
                <Link to="/">
                  <img
                    src="/img/ford-gelisim-akademi-logo.png"
                    className="img-fluid"
                    alt="Ford Gelişim Akademi"
                    style={{ marginBottom: "-4%" }}
                  />
                </Link>
              </div>

              <div className="col-7 col-sm-7 col-md-9 col-lg-9 col-xl-10">
                <ul className="notif">
                  <li>{this.renderProfileBar()}</li>
                </ul>
              </div>
            </div>
          </div>
        </header>
        {/* {this.renderMobileMenu()} */}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    generalProfile: state.profile.general,
  };
};

export default connect(mapStateToProps, {})(withRouter(Header));
